import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  selectAiChatPendingToolConfirmationsByMessageId,
  selectAiChatPendingToolExecution,
} from 'store/aiChat/selectors';

import ToolConfirmationEntry from './components/ToolConfirmationEntry';
import { TOOL_CONFIRMATION_FLOW } from './ToolConfirmationCard.constants';
import { cardListStyles } from './ToolConfirmationCard.styles';
import { mapPendingToolExecutionToConfirmation } from './ToolConfirmationCard.utils';

const ToolConfirmationCard = ({ messageId }) => {
  const backendConfirmations = useSelector(state =>
    selectAiChatPendingToolConfirmationsByMessageId(state, messageId),
  );
  const pendingToolExecution = useSelector(selectAiChatPendingToolExecution);

  const entries = useMemo(() => {
    const backendEntries = backendConfirmations.map(confirmation => ({
      confirmation,
      flow: TOOL_CONFIRMATION_FLOW.BACKEND,
    }));

    const frontendConfirmation =
      pendingToolExecution?.messageId === messageId
        ? mapPendingToolExecutionToConfirmation(pendingToolExecution)
        : null;

    return _.isNil(frontendConfirmation)
      ? backendEntries
      : [
          ...backendEntries,
          { confirmation: frontendConfirmation, flow: TOOL_CONFIRMATION_FLOW.FRONTEND },
        ];
  }, [backendConfirmations, messageId, pendingToolExecution]);

  if (_.isNil(messageId) || entries.length === 0) {
    return null;
  }

  return (
    <Box sx={cardListStyles}>
      {entries.map(({ confirmation, flow }) => (
        <ToolConfirmationEntry
          confirmation={confirmation}
          flow={flow}
          key={confirmation.toolCallId}
          messageId={messageId}
        />
      ))}
    </Box>
  );
};

ToolConfirmationCard.propTypes = {
  messageId: PropTypes.string,
};

export default memo(ToolConfirmationCard);
